const API_URL = process.env.NEXT_PUBLIC_API_URL || 'http://localhost:3001';

export type Locale = 'es' | 'en' | 'pt' | 'de' | 'fr';
export type SiteCopy = Record<string, string>;
export type SiteCopyByLocale = Record<Locale, SiteCopy>;

const LOCALES: Locale[] = ['es', 'en', 'pt', 'de', 'fr'];
const EMPTY: SiteCopyByLocale = { es: {}, en: {}, pt: {}, de: {}, fr: {} };

export async function getSiteCopy(locale: Locale): Promise<SiteCopy> {
    try {
        const res = await fetch(`${API_URL}/api/marketing/copy/${locale}`, {
            next: { revalidate: 60 },
        });
        if (!res.ok) return {};
        return res.json();
    } catch {
        return {};
    }
}

export async function getAllSiteCopy(): Promise<SiteCopyByLocale> {
    try {
        const entries = await Promise.all(
            LOCALES.map(async (l) => [l, await getSiteCopy(l)] as const),
        );
        const out = { ...EMPTY };
        for (const [l, map] of entries) out[l] = map;
        return out;
    } catch {
        return EMPTY;
    }
}

export function copyOr(map: SiteCopy | undefined, key: string, fallback: string): string {
    const v = map?.[key];
    return v && v.trim().length > 0 ? v : fallback;
}

export interface DynamicNavItem {
    id: string;
    parentId: string | null;
    labelEs: string;
    labelEn: string;
    labelPt: string;
    kind: 'link' | 'landing' | 'dropdown';
    href: string | null;
    landingSlug: string | null;
    isActive: boolean;
    children?: DynamicNavItem[];
}

export async function getNavTree(): Promise<DynamicNavItem[]> {
    try {
        const res = await fetch(`${API_URL}/api/marketing/nav`, { next: { revalidate: 30 } });
        if (!res.ok) return [];
        return res.json();
    } catch {
        return [];
    }
}
